import BaseBranding from "%/dynamic-components/render-engine/classes/branding/base-branding";
import TextBrandingStyleOption
  from "%/dynamic-components/render-engine/options/text-options/text-branding-style-option";
import useBrandingStore from "%/stores/branding-store";

export default class TypographyBranding extends BaseBranding {
  static inheritanceStructure = {
    base: "standard",
    inherits: {
      accent: ["standard"],
      subtle: ["standard"],
    },
  };

  static isThemableOptionKey(optionKey) {
    const keys = Object.keys(useBrandingStore().defaultTemplateConfiguration["BrandedHeadingElement"]["standard"]);
    return keys.includes(`default.${optionKey}`);
  }

  findNextInheritanceLevel(variant, size) {
    const inheritanceLevels = TypographyBranding.inheritanceStructure.inherits[variant] || [];
    const currentLevelIndex = inheritanceLevels.indexOf(size);
    if (currentLevelIndex === -1 || currentLevelIndex === 0) {
      return { variant: TypographyBranding.inheritanceStructure.base, size: null };
    }

    return {
      variant: inheritanceLevels[currentLevelIndex - 1] || TypographyBranding.inheritanceStructure.base,
      size: null,
    };
  }

  determineType(elementConfig, breakpoint, state, availableBreakpoints) {
    const textStyleOption = this.processInheritance(
      elementConfig.options,
      "text-style-option",
      breakpoint,
      state,
      availableBreakpoints,
    );
    const textBrandingStyleOption = this.processInheritance(
      elementConfig.options,
      "text-branding-style-option",
      breakpoint,
      state,
      availableBreakpoints,
    );

    const types = Object.keys(TextBrandingStyleOption.VariantOptions);
    const typeFromElementType = types.find(type => {
      return TextBrandingStyleOption.VariantOptions[type] === elementConfig.type;
    });

    return TextBrandingStyleOption.VariantOptions[textStyleOption || textBrandingStyleOption || typeFromElementType || "paragraph"];
  }

  determineVariant(elementConfig, breakpoint, state, availableBreakpoints) {
    const variant = this.processInheritance(elementConfig.options, "styled-text-variant", breakpoint, state, availableBreakpoints);
    return variant || "standard";
  }

  determineSize() {
    return undefined;
  }
}
